import React from 'react';
import { Wrapper } from './styles';
import DashboardHeader from './components/DashboardHeader';
import SummaryStatistics from './components/SummaryStatistics';
import NoticeSection from './components/NoticeSection';
import { Notice } from '../../Modules/Notice/Model/Notice';

import { useAppSelector } from '../../Modules/Presentation/hooks';
import { selectNotices } from '../../Modules/Notice/Presentation/selectors';
import {
  selectDashboardEndTodaySlotCount,
  selectDashboardRunningSlotCount,
  selectDashboardTotalSlotCount,
} from '../../Modules/Dashboard/Presentation/selectors';


const DashboardPage: React.FC = () => {
  const totalSlots = useAppSelector(selectDashboardTotalSlotCount);
  const runningSlots = useAppSelector(selectDashboardRunningSlotCount);
  const endTodaySlots = useAppSelector(selectDashboardEndTodaySlotCount);
  const notices = useAppSelector(selectNotices);


  return (
    <Wrapper>
      <DashboardHeader />
      <SummaryStatistics
        total={totalSlots}
        running={runningSlots}
        endToday={endTodaySlots}
      />
      <NoticeSection notices={notices} />
    </Wrapper>
  );
};

export default DashboardPage;
